export enum DataType {
  String,
  Number,
  Date,
  Boolean
}